module.exports = __webpack_public_path__ + "media/images/emblems/Toffen-coat_of_arms-818b8fa3582814452e2fcc4337acce67.svg";